/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DateOfBirth from './DateOfBirth/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import Greeting from './Greeting/index'
import LastName from './LastName/index'
import MiddleName from './MiddleName/index'
import React from 'react'
import Ssn from './Ssn/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Details"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Details.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Details.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<MiddleName
  viewPath={`${viewPath}/MiddleName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
</div>
<div
  data-testid="Details.Vertical:1"
  data-view-path={viewPath}
 style={{'--pr-1-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<Greeting
  viewPath={`${viewPath}/Greeting`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
<Ssn
  viewPath={`${viewPath}/Ssn`}
/>
</div>
</div>
{children}
</React.Fragment>)
}